const COLOR_MAP = {
  white: "#FFFFFF",
  beyaz: "#FFFFFF",
  black: "#1A1A1A",
  siyah: "#1A1A1A",
  gray: "#9CA3AF",
  grey: "#9CA3AF",
  gri: "#9CA3AF",
  beige: "#D8C9A8",
  bej: "#D8C9A8",
  oak: "#C19A6B",
  meşe: "#C19A6B",
  walnut: "#6B4A2B",
  brown: "#8B5E3C",
  natural: "#DCC9A8",
  blue: "#3B82F6",
  mavi: "#3B82F6",
  green: "#1C4E35",
  yeşil: "#1C4E35",
  red: "#DC2626",
  kırmızı: "#DC2626",
  yellow: "#EAB308",
  orange: "#F97316",
  silver: "#C0C0C0",
  cream: "#F5F0DC",
};

const findColor = (variant) => {
  const words = (variant || "").toLowerCase().split(/[^a-zçğıöşü0-9]+/);
  for (const w of words) if (COLOR_MAP[w]) return COLOR_MAP[w];
  return null;
};

export const VariantBadge = ({ variant }) => {
  if (!variant) return <span className="text-xs text-stone-300">—</span>;
  const color = findColor(variant);
  return (
    <span
      className="inline-flex max-w-[180px] items-center gap-1.5 border border-stone-300 bg-white px-2 py-0.5 text-[11px] font-medium text-stone-700"
      data-testid="variant-badge"
      title={variant}
    >
      {color && (
        <span
          className="h-2.5 w-2.5 shrink-0 rounded-full border border-stone-300"
          style={{ backgroundColor: color }}
        />
      )}
      <span className="truncate">{variant}</span>
    </span>
  );
};
